import { Flex, ModuleLayout, Spacing } from '@billy/design-system'
import Cookies from 'js-cookie'
import { ReactElement } from 'react'
import { useParams } from 'react-router'

import { CookieKeys } from '../../../../enums/cookieKeys'
import { useOrganizationViewUrl } from '../../../../hooks/routing/useOrganizationViewUrl'
import { reactRoute } from '../../../../utils/routing/reactRoute'
import { QuoteContextProvider } from './contexts/quoteContext'
import { QuotePreview } from './elements/QuotePreview'
import { QuoteTitle } from './elements/QuoteTitle'
import { QuoteViewActions } from './elements/QuoteViewActions'
import { QuoteViewSidebar } from './elements/QuoteViewSidebar'

// react-router-v5-compat's useParams<T>() constrains T to Record<string, string | undefined>,
// which a named interface does not satisfy because it has no implicit index signature.
type QuoteViewUrlParams = {
  quoteId: string
}

export const QuoteView = (): ReactElement | null => {
  const { quoteId } = useParams<QuoteViewUrlParams>()
  const { url: quotesUrl } = useOrganizationViewUrl(reactRoute.organization.quotes.getMainRoute())

  const storedQuotesListQuery = Cookies.get(CookieKeys.QuotesListQuery) || ''

  if (!quoteId) {
    return null
  }

  return (
    <QuoteContextProvider quoteId={quoteId}>
      <ModuleLayout
        backButtonTo={quotesUrl && `${quotesUrl}${storedQuotesListQuery}`}
        sideActions={<QuoteViewActions />}
        title={<QuoteTitle />}
        withBackButton
      >
        <Flex justifyContent="center">
          <Flex flexDirection="column" gap={Spacing.S24} width="fit-content">
            <Flex gap={Spacing.S24} justifyContent="center" width="fit-content">
              <QuotePreview />
              <QuoteViewSidebar />
            </Flex>
          </Flex>
        </Flex>
      </ModuleLayout>
    </QuoteContextProvider>
  )
}
